"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartLabelsPlugin = exports.chartYearChangeLineLabelPlugin = exports.chartAreaHighlighter = void 0;
var asg_1 = require("@alinta-digital/asg");
var date_fns_1 = require("date-fns");
function highlightBackground(chart, activeIndex, noOfColumns, isSolar, hasSolar) {
    var ctx = chart.ctx;
    var chartArea = chart.chartArea;
    var columnCount = Number(noOfColumns);
    var width = chartArea.right - chartArea.left;
    var height = chartArea.bottom - chartArea.top;
    var columnWidth = width / columnCount;
    // includes x-axis label on the active-shadow draw
    var topAddition = isSolar ? -20 : 0;
    var heightAddition = isSolar ? 20 : hasSolar ? 40 : 0;
    ctx.save();
    var startPoint = chartArea.left;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(startPoint, chartArea.top + topAddition, width, height + heightAddition);
    ctx.fillStyle = '#EEEEEE';
    if (activeIndex !== 0) {
        startPoint += columnWidth * activeIndex;
    }
    ctx.fillRect(startPoint, chartArea.top + topAddition, columnWidth, height + heightAddition);
    ctx.restore();
}
/** draw active index shadow */
exports.chartAreaHighlighter = {
    id: 'chartAreaHighlighter',
    beforeDraw: function (chart, _args, options) {
        if (options.disablePlugin || !chart.chartArea) {
            return;
        }
        var activeIndex = Number(options.activeIndex);
        var noOfColumns = Number(options.noOfColumns);
        highlightBackground(chart, activeIndex, noOfColumns, options.isSolar, options.hasSolar);
    },
};
/** Draw year change text (2023) and vertical line. */
exports.chartYearChangeLineLabelPlugin = {
    id: 'yearChangeLineLabel',
    beforeDatasetsDraw: function (chart, _args, options) {
        var usagePeriods = options.usagePeriods;
        if (usagePeriods.length === 0) {
            return;
        }
        var ctx = chart.ctx, chartArea = chart.chartArea, scales = chart.scales;
        var dataPointAmt = usagePeriods.length;
        var dataPointWidth = chart.chartArea.width / dataPointAmt;
        var fontSize = 13;
        ctx.beginPath();
        ctx.lineWidth = 0.1;
        ctx.strokeStyle = '#68727C';
        ctx.textAlign = 'left';
        ctx.font = "".concat(fontSize, "px stevie-sans, Arial, Tahoma, sans-serif");
        ctx.textBaseline = 'top';
        for (var i = 0; i < dataPointAmt; i++) {
            var usageData = usagePeriods[i];
            if (!usageData.endOfPeriod) {
                continue;
            }
            var prevUsageData = usagePeriods[i - 1];
            var startYear = (0, date_fns_1.getYear)(new Date(usageData.startOfPeriod));
            var endYear = (0, date_fns_1.getYear)(new Date(usageData.endOfPeriod));
            var prevEndYear = prevUsageData ? (0, date_fns_1.getYear)(new Date(prevUsageData.endOfPeriod)) : startYear;
            var yearChanged = prevEndYear !== startYear || startYear !== endYear;
            var isFirstDataPoint = i === 0;
            if (!yearChanged && !isFirstDataPoint) {
                continue;
            }
            var xAxisTickMiddle = scales.x.getPixelForTick(i) - dataPointWidth / 2;
            var paddingX = 5;
            var paddingY = 22;
            var x = xAxisTickMiddle + paddingX;
            var y = chartArea.top - paddingY;
            // draw text with background
            var labelText = " ".concat(endYear, " \u27F6 ");
            var labelTextWidth = ctx.measureText(labelText).width;
            ctx.fillStyle = asg_1.colors.white;
            ctx.fillRect(x, y, labelTextWidth, fontSize);
            ctx.fillStyle = asg_1.colors.tertiaryText.light;
            ctx.fillText(labelText, x, y);
            if (!isFirstDataPoint) {
                // draw vertical line
                ctx.moveTo(xAxisTickMiddle, chartArea.bottom);
                ctx.lineTo(xAxisTickMiddle, chartArea.top);
            }
        }
        ctx.stroke();
    },
};
/** Call period change callback when a x-axis label is clicked */
exports.chartLabelsPlugin = {
    id: 'chartLabels',
    beforeEvent: function (chart, args, _a) {
        var _b, _c;
        var usagePeriods = _a.usagePeriods, activeUsagePeriodIndex = _a.activeUsagePeriodIndex, onUsagePeriodChange = _a.onUsagePeriodChange, dragging = _a.dragging;
        if (dragging || args.event.type !== 'click' || args.event.x === null || !onUsagePeriodChange) {
            return;
        }
        var valueIndex = chart.scales.x.getValueForPixel(args.event.x);
        if (valueIndex === undefined || valueIndex < 0 || valueIndex > usagePeriods.length - 1) {
            return;
        }
        if (valueIndex === activeUsagePeriodIndex) {
            return;
        }
        var usagePeriod = usagePeriods[valueIndex];
        if (!usagePeriod) {
            return;
        }
        onUsagePeriodChange((_c = (_b = usagePeriods[valueIndex]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '');
    },
};
//# sourceMappingURL=DailyUsageGraph.plugins.js.map